import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="chart"
export default class extends Controller {
  static targets = ["canvas"]
  static values = { 
    chartData: Object,
    chartOptions: Object,
    chartType: { type: String, default: "line" }
  }

  connect() {
    console.log("Chart controller connected")
    console.log("Chart data:", this.chartDataValue)
    console.log("Chart type:", this.chartTypeValue)
    this.chart = null
    
    // Initialize chart after a short delay to ensure everything is loaded
    setTimeout(() => this.initializeChart(), 100)
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }

  initializeChart() {
    // Check if Chart.js is available
    if (typeof window.Chart === 'undefined') {
      console.error("Chart.js is not available")
      return
    }

    console.log("Initializing chart with data:", this.chartDataValue)
    console.log("Available Chart constructors:", Object.keys(window.Chart))

    // Destroy existing chart if it exists
    if (this.chart) {
      this.chart.destroy()
    }

    try {
      const ctx = this.canvasTarget.getContext('2d')
      
      // Ensure we have valid data
      if (!this.chartDataValue || !this.chartDataValue.labels || !this.chartDataValue.datasets) {
        console.warn("Invalid chart data:", this.chartDataValue)
        // Show empty chart with placeholder
        this.chartDataValue = {
          labels: ['No Data'],
          datasets: [{
            label: '暂无数据',
            data: [0],
            borderColor: 'rgb(156, 163, 175)',
            backgroundColor: 'rgba(156, 163, 175, 0.1)',
          }]
        }
      }
      
      const config = {
        type: this.chartTypeValue,
        data: this.chartDataValue,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            title: {
              display: true,
              text: '每日完成情况趋势图'
            },
            legend: {
              position: 'top',
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                stepSize: 1
              }
            }
          },
          interaction: {
            intersect: false,
            mode: 'index'
          },
          ...this.chartOptionsValue
        }
      }

      console.log("Creating chart with config:", config)
      this.chart = new window.Chart(ctx, config)
      console.log("Chart created successfully:", this.chart)
    } catch (error) {
      console.error("Error creating chart:", error)
      console.error("Chart type:", this.chartTypeValue)
      console.error("Chart data:", this.chartDataValue)
    }
  }

  // Public method to update chart data
  updateChart(newData) {
    if (this.chart) {
      this.chart.data = newData
      this.chart.update()
    }
  }
}
